import React from "react";
import { Landmark } from "lucide-react";
import { LEADERS } from "../lib/content";

const Leaders = () => (
  <section
    id="leaders"
    data-testid="section-leaders"
    className="relative py-16 sm:py-20 bg-alabaster-surface overflow-hidden"
  >
    <div className="max-w-7xl mx-auto px-6 sm:px-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-12 items-end">
        <div className="lg:col-span-7 reveal">
          <div className="eyebrow inline-flex items-center gap-3">
            <span className="block w-10 h-px bg-terracotta" />
            Recognized at the Highest Level
          </div>
          <h2
            data-testid="leaders-heading"
            className="font-display mt-5 text-4xl sm:text-5xl lg:text-6xl font-bold text-ink leading-[1.05] tracking-tight"
          >
            Meeting Palestinian <br />
            <span className="text-terracotta">national leaders.</span>
          </h2>
        </div>
        <div className="lg:col-span-5 reveal">
          <p className="text-ink-soft text-base sm:text-lg leading-relaxed">
            Invited by ministers and governors to present my innovations — aligning next-generation technology with Palestine's national education and development goals.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
        {LEADERS.map((l, i) => (
          <article
            key={l.name}
            data-testid={`leader-card-${i}`}
            className="reveal group bg-white border border-alabaster-line rounded-3xl overflow-hidden hover:border-terracotta/50 hover:-translate-y-2 hover:shadow-[0_30px_60px_-30px_rgba(28,32,30,0.25)] transition-all duration-500"
            style={{ transitionDelay: `${i * 90}ms` }}
          >
            <div className="relative aspect-[16/10] overflow-hidden bg-ink">
              <img
                src={l.image}
                alt={`Yazid M. Al-Badarin with ${l.name}`}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent" aria-hidden />
              <div className="absolute left-5 bottom-5 right-5">
                <div className="inline-flex items-center gap-2 bg-terracotta text-ink rounded-full px-3 py-1.5 eyebrow !text-[10px] !text-ink">
                  <Landmark size={12} strokeWidth={2.4} />
                  {l.role}
                </div>
              </div>
            </div>

            <div className="p-7">
              <h3 className="font-display text-2xl font-bold text-ink leading-snug group-hover:text-terracotta transition-colors">
                {l.name}
              </h3>
              <div className="mt-1 text-xs font-display font-semibold tracking-wide text-ink-soft/80 uppercase">
                {l.org}
              </div>
              <p className="mt-4 text-sm text-ink-soft leading-relaxed">
                {l.body}
              </p>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default Leaders;
